const yellow = 0xfacf5a;
const blue = 0x2080d5;
const darkGray = 0x6b6b6b;
const white = 0xffffff;
const pink = 0xff7070;
const hotPink = 0xFF69B4;
const green = 0x88bc38;
const neonGreen = 0x32CD32;  // Updated to a darker shade of neon green
const black = 0x000000;
const red = 0xff0000;
const orange = 0xffa500;
const turquoise = 0x40e0d0;
const purple = 0x6A5ACD;
const babyBlue = 0x483D8B;
const powderBlue = 0x7B68EE;
const cornflowerBlue = 0x6495ed;
const steelBlue = 0x4682b4;
const dodgerBlue = 0x1e90ff;
const royalBlue = 0x4169e1;
const navyBlue = 0x000080;
const midnightBlue = 0x191970;
const gold = 0xFFD700;
const goldenRod = 0xDAA520;
const indigo = 0x4B0082;
const lightGray = 0xababab;


export { yellow, blue, white, darkGray, pink, hotPink, green, neonGreen, black, red, orange, turquoise, purple, babyBlue, powderBlue, cornflowerBlue, steelBlue, dodgerBlue, royalBlue, navyBlue, midnightBlue, gold, goldenRod, indigo, lightGray};
